import { useState } from "react";
import { Ruler } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

// Approx. measurements for the Gildan blanks we print on (inches).
const ADULT = [
  { size: "S", chest: "34–37", length: "28" },
  { size: "M", chest: "38–41", length: "29" },
  { size: "L", chest: "42–45", length: "30" },
  { size: "XL", chest: "46–49", length: "31" },
  { size: "2XL", chest: "50–53", length: "32" },
];

const YOUTH = [
  { size: "XS", chest: "26–27", length: "20" },
  { size: "S", chest: "28–29", length: "22" },
  { size: "M", chest: "30–32", length: "24" },
  { size: "L", chest: "32–34", length: "26" },
  { size: "XL", chest: "34–36", length: "28" },
];

const Table = ({ title, rows }) => (
  <div>
    <p className="text-[11px] uppercase tracking-[0.25em] font-bold text-primary mb-2">{title}</p>
    <div className="border border-white/10 overflow-hidden">
      <div className="grid grid-cols-3 bg-white/5 text-[10px] uppercase tracking-[0.15em] font-bold text-white/50">
        <div className="px-3 py-2">Size</div>
        <div className="px-3 py-2">Chest (in)</div>
        <div className="px-3 py-2">Length (in)</div>
      </div>
      {rows.map((r) => (
        <div key={r.size} className="grid grid-cols-3 text-sm text-white/80 border-t border-white/10">
          <div className="px-3 py-2 font-bold text-white">{r.size}</div>
          <div className="px-3 py-2">{r.chest}</div>
          <div className="px-3 py-2">{r.length}</div>
        </div>
      ))}
    </div>
  </div>
);

export const SizeChart = ({ hasYouth = false }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="size-chart-trigger"
          className="flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold text-white/50 hover:text-primary transition-colors"
        >
          <Ruler className="w-3.5 h-3.5" /> Size chart
        </button>
      </DialogTrigger>
      <DialogContent
        data-testid="size-chart-dialog"
        className="bg-neutral-950 border-white/15 text-white max-w-lg"
      >
        <DialogHeader>
          <DialogTitle className="font-anton text-2xl uppercase tracking-tight">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-white/50 -mt-1">
          Measurements are approximate. Chest is the garment laid flat, measured across and doubled.
          Between sizes? Size up for a relaxed fit.
        </p>
        <div className="space-y-5 mt-2">
          <Table title="Adult" rows={ADULT} />
          {hasYouth && <Table title="Youth" rows={YOUTH} />}
        </div>
        <p className="text-[11px] text-white/40 mt-1">Tip: hoodies run slightly roomier than tees.</p>
      </DialogContent>
    </Dialog>
  );
};
